<!-- https://www.freecodecamp.org/news/everything-you-need-to-know-about-ng-template-ng-content-ng-container-and-ngtemplateoutlet-4b7b51223691/ -->
<ion-icon
  *ngIf="icon"
  [name]="icon"
  [attr.aria-label]="iconAriaLabel"
  [attr.aria-hidden]="!iconAriaLabel ?? true"
  [ngClass]="headingStyle || heading"
  [color]="iconColor"
>
</ion-icon>
<ng-container [ngSwitch]="heading">
  <h1
    [class]="headingStyle ? headingStyle : 'h1'"
    *ngSwitchCase="'h1'"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h1>
  <h2
    [class]="headingStyle ? headingStyle : 'h2'"
    *ngSwitchCase="'h2'"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h2>
  <h2
    [class]="headingStyle ? headingStyle : 'h2-profile'"
    *ngSwitchCase="'h2-profile'"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h2>
  <h3
    [class]="headingStyle ? headingStyle : 'h3'"
    *ngSwitchCase="'h3'"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h3>
  <h4
    [class]="headingStyle ? headingStyle : 'h4'"
    *ngSwitchCase="'h4'"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h4>
  <h5
    [class]="headingStyle ? headingStyle : 'h5'"
    *ngSwitchCase="'h5'"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </h5>
  <!-- <ng-content select=".description"></ng-content> -->
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
